<div class="registration-container">
  <div class="page-container">
    <div class="group" *ngIf="phase === 'loading'">
      <app-spinner></app-spinner>
    </div>
    <div class="group" *ngIf="phase === 'changing'">
      <h1>Updating your membership...</h1>
      <app-spinner></app-spinner>

      <p>Just a second while we adjust everything!</p>
    </div>
    
    <div class="group" *ngIf="phase === 'confirm'">
      <header>
        <tyt-plus-tag></tyt-plus-tag>
        <div class="title">
          Change Membership Plan
        </div>
      </header>

      <error-message></error-message> <!-- TODO/BLOCKED -->

      <div class="preview">
        <div class="product">
          <header>Current Plan</header>
          <div class="box">
            <div class="plan">
              <div class="name">
                {{membership.product.name}}
              </div>
              <div class="period">
                {{periodFriendly(membership.product.period)}}
              </div>
              <div class="price">
                {{currentPrice | currency:'USD':true}}
              </div>
            </div>
            <details>
              <summary>
                <div class="icon-container closed"><i class="fas fa-chevron-down"></i></div>
                <div class="icon-container opened"><i class="fas fa-chevron-up"></i></div>
                Show Plan Benefits
              </summary>
              <div *ngIf="membership.product" class="offer-benefits">
                <div class="benefits" [innerHTML]="membership.product.description | trustHtml"></div>
                <tyt-membership-features
                  class="mini"
                  [product]="membership.product"
                  ></tyt-membership-features>
              </div>
            </details>
          </div>
        </div>
        <div class="to">
          <i class="fas fa-chevron-right"></i>
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="product">
          <header>New Plan</header>
          <div class="box">
            <div class="plan">
              <div class="name">
                {{newName}}
              </div>
              <div class="period">
                {{periodFriendly(newPeriod)}}
              </div>
              <div class="price">
                {{newPriceUSD | currency:'USD':true}}
              </div>
            </div>
            <details>
              <summary>
                <div class="icon-container closed"><i class="fas fa-chevron-down"></i></div>
                <div class="icon-container opened"><i class="fas fa-chevron-up"></i></div>
                Show Plan Benefits
              </summary>
              <div *ngIf="product" class="offer-benefits">
                <div class="benefits" [innerHTML]="product.description | trustHtml"></div>
                <tyt-membership-features
                  class="mini"
                  [product]="product"
                  ></tyt-membership-features>
              </div>
            </details>
          </div>
          <div class="product-decision">
            <div class="action-summary">
              
              <ng-container *ngIf="!prorated">
                <!-- 
                  There's a bit of an implicit assumption here, that we only use non-prorated changes when we are 
                  having the user pay early (early_renewal=true on the offer). We don't yet expose this flag via the API
                  TODO: Once we have exposed this flag, only use nextFullRenewalDate() when we are doing early renewal.
                -->
                You will be charged <span class="currency-debit">{{proratedCost / 100 | currency:'USD':true}}</span>
                immediately. You will then be charged {{( 
                  newFullPriceUSD 
                ) | currency:'USD':true}}
                on 
                  {{nextFullRenewalDate() | date:'shortDate'}}.    
              </ng-container>
              <ng-container *ngIf="prorated">
                <div *ngIf="!periodChange">
                  <div *ngIf="proratedCost >= 0">
                    <p class="primary">The membership change is pro-rated, 
                      so you will be charged <span class="currency-debit">{{proratedCost / 100 | currency:'USD':true}}</span>
                      immediately. You will then be charged 
                      {{( 
                        newPriceUSD
                      ) | currency:'USD':true}}
                      on {{user.membership.status.renewal_due_date | date:'shortDate'}}.    
                    </p>
                  </div>
                  <div *ngIf="proratedCost < 0">
                    <p class="primary">
                      You will have a credit of <span class="currency-credit">{{-1 * proratedCost / 100 | currency:'USD':true}}</span>. 
                      This credit will apply against your future membership payments. You will then be charged 
                      {{( 
                        newPriceUSD
                      ) | currency:'USD':true}} once this credit is used up.
                    </p>
                  </div>
                </div>

                <div *ngIf="periodChange">
                  <div *ngIf="proratedCost >= 0">
                    <p class="primary">The membership change is pro-rated, 
                      so you will be charged <span class="currency-debit">{{proratedCost / 100 | currency:'USD':true}}</span>
                      immediately. You will then be charged 
                      {{( 
                        newPrice / 100
                      ) | currency:'USD':true}} on {{user.membership.status.renewal_due_date | date:'shortDate'}}. 
                    </p>
                  </div>
                  <div *ngIf="proratedCost < 0">
                    <div *ngIf="product.monthly_price + proratedCost >= 0">
                      <p class="primary">
                        You will be charged
                        <span class="currency-debit">
                          {{(
                            newPrice
                            + proratedCost) / 100 | currency:'USD':true}}</span> immediately based on a credit 
                        from your previous membership of 
                        <span class="currency-credit">{{-1 * proratedCost / 100 | currency:'USD':true}}</span>.
                        Your billing cycle will be reset so that you will be charged circa 
                        {{newChargeDate | date:'shortDate'}}. 
                      </p>
                    </div>

                    <div *ngIf="product.monthly_price + proratedCost < 0">
                      <p class="primary">
                        You will have a credit of <span class="currency-credit">{{-1 * proratedCost / 100 | currency:'USD':true}}</span>. 
                        This credit will apply against your future membership payments. You will then be charged 
                        {{( 
                          product.price / 100 
                        ) | currency:'USD':true}} once this credit is used up. 
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="billing" *ngIf="paymentSource">
                <label>
                  Billed to:
                </label>
                <div class="card">
                  {{paymentSource.brand}} **{{paymentSource.last4}} {{paymentSource.exp_month}}/{{paymentSource.exp_year}}
                </div>
                <a routerLink="/billing/update">Change Card</a>
              </div>
            </div>

            <div class="confirm-label">Confirm Plan Change</div>

            <a class="action-button no-arrow confirm" (click)="submit()">Yes, proceed with change</a>
            <div class="sub-actions">
              <a *ngIf="!offer" class="action-button no-arrow back" routerLink="/membership/change">No keep my Current Membership</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="group" *ngIf="phase === 'success'">
      <div class="page-title">Your membership has been updated</div>
      <h5>Your new membership level is:</h5>
      <div>
        {{product.dollar_price | currency:'USD':true}} | {{ capitalizeFirstLetter(product.period) }}
        <div [innerHTML]="product.description | trustHtml" class="offer-benefits"></div>
      </div>

      <div class="product-decision">
        <a routerLink="/accounts">Back to My Account</a>
      </div>
    </div>
  </div>
</div>
